import { MouseEvent } from 'react';
import styles from './FooterLanguages.module.scss';

import cx from 'classnames';

export interface Language {
  descriptionString: string;
  href: string;
  languageId: string;
  localeName: string;
  nativeDescription?: string;
  nativeDescriptionString: string;
  seoToken: string;
}

interface FooterLanguagesProps {
  languages: Language[];
  langId: string;
  isMobile?: boolean;
  isMobileFooterDesignUpdate?: boolean;
  onClick?: (e: MouseEvent, language: Language) => void;
}

export const FooterLanguages = ({
  languages,
  langId,
  isMobile,
  isMobileFooterDesignUpdate,
  onClick
}: FooterLanguagesProps) => (
  <div className={`${styles['footer__language']}`}>
    <div className={`${styles['footer__language-listitem']}`}>
      {languages?.map((language) => {
        const isActive = langId === language?.languageId;

        const desktopClass = cx({
          [styles['footer_language-button-active']]: isActive
        });
        const mobileClass = cx({
          [styles['footer_language-button-active']]:
            isActive && !isMobileFooterDesignUpdate,
          [styles['footer_language-button-mobile-active-mobile']]:
            isActive && isMobileFooterDesignUpdate,
          [styles['footer_language-button-inactive-mobile']]:
            !isActive && isMobileFooterDesignUpdate
        });

        const mobileClassInital = cx({
          [styles['footer__language-button-mobile']]:
            isMobileFooterDesignUpdate,
          [styles['footer__language-button']]: !isMobileFooterDesignUpdate
        });

        const baseClass = 'exclude-global';

        const desktopClassName = `${baseClass} ${styles['footer__language-button']} ${desktopClass}`;
        const mobileClassName = `${baseClass} ${mobileClassInital} ${mobileClass}`;

        const buttonClass = isMobile ? mobileClassName : desktopClassName;

        return (
          <a
            href={language.href}
            className={buttonClass}
            key={language.localeName}
            aria-label={language.nativeDescriptionString}
            onClick={(e) => (onClick ? onClick(e, language) : void 0)}
          >
            {language.nativeDescriptionString}
          </a>
        );
      })}
    </div>
  </div>
);
